import { memo } from 'react';
import SimplifiedStepSection from '@quicktools/shared-components/components/landingPages/SimplifiedStepSection';
import UploadButton from '@quicktools/shared-components/components/core/UploadButton';
import { UploadType } from '@quicktools/shared-components/components/core/UploadArea';
import { IStep } from '@quicktools/shared-components/components/landingPages/SimplifiedStepSection';
import { useTranslation } from 'react-i18next';
import IconPlusLarge from '@picsart/icons/IconPlusLarge';

import { appConfig } from '../../configs';

export interface IHowToSection {
  onUpload: (files: File[], uploadType?: UploadType) => void;
}

function HowToSection({ onUpload }: IHowToSection) {
  const { t } = useTranslation();
  const steps: IStep[] = Array.from(Array(3)).map((_, index) => ({
    title: t(`landing.howToSection.steps.${index}.title`),
    description: t(`landing.howToSection.steps.${index}.description`),
  }));

  return (
    <SimplifiedStepSection
      cta={
        <UploadButton accept={appConfig.accept} multiple onChange={onUpload}>
          <IconPlusLarge />
          {t('landing.howToSection.cta')}
        </UploadButton>
      }
      title={t('landing.howToSection.title')}
      steps={steps}
    />
  );
}

export default memo(HowToSection);
